var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManualReporting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "img saisie manuelle"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3463216",
    width: 32,
    height: 32,
    rx: 3,
    fill: "url(#paint0_linear_5751_10987)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_dd_5751_10987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4444 12H6.55556C6.24867 12 6 12.2487 6 12.5556V20.3333C6 20.6402 6.24867 20.8889 6.55556 20.8889H25.4444C25.7513 20.8889 26 20.6402 26 20.3333V12.5556C26 12.2487 25.7513 12 25.4444 12ZM18.7778 19.7778H7.11111V13.1111H18.7778V19.7778ZM24.8889 19.7778H19.3333V13.1111H24.8889V19.7778Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9147 18.5853C21.9689 18.6396 22.04 18.6667 22.1111 18.6667C22.1822 18.6667 22.2533 18.6396 22.3076 18.5853L23.4187 17.4742C23.498 17.3949 23.5218 17.2753 23.4789 17.1716C23.4358 17.0678 23.3344 17 23.2222 17H21C20.8878 17 20.7864 17.0678 20.7433 17.1713C20.7004 17.2751 20.7242 17.3947 20.8035 17.474L21.9147 18.5853Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 15.8889H23.2222C23.2238 15.8889 23.2251 15.8887 23.2267 15.8889C23.38 15.8889 23.5044 15.7644 23.5044 15.6111C23.5044 15.5193 23.46 15.438 23.3913 15.3873L22.3076 14.3036C22.1991 14.1951 22.0233 14.1951 21.9147 14.3036L20.8035 15.4147C20.7242 15.494 20.7004 15.6136 20.7433 15.7173C20.7864 15.8211 20.8878 15.8889 21 15.8889Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_5751_10987",
    x: 4.2,
    y: 11,
    width: 23.6,
    height: 12.4887,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.9
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5751_10987"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.225
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5751_10987",
    result: "effect2_dropShadow_5751_10987"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_5751_10987",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5751_10987",
    x1: 29.9717,
    y1: 7.39624,
    x2: 24.9079,
    y2: 26.0586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BB3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787BD2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualReporting);
export default __webpack_public_path__ + "static/media/manual_reporting.d97dce88781469438846d083c3bc804c.svg";
export { ForwardRef as ReactComponent };